class Type {

	public static OFF = new Type(0, "v9");
	public static DETAIL = new Type(1, "v10 - Detail Pages Only");
	public static ALL = new Type(2, "v10")

	private constructor(
		public readonly id: number,
		public readonly label: string,
	) {
	}

	public static get default(): Type {
		return this.OFF;
	}

	public get off() {
		return this === Type.OFF;
	}

	public get detail() {
		return this === Type.DETAIL;
	}

	public get all() {
		return this === Type.ALL;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static valuesSorted(): Type[] {
		return this.values().sort((a,b) => a.id - b.id);
	}

	public static getById(id?: number) {
		return this.values().find(value => value.id === id)
	}

	public static getByIdOrDefault(id?: number): Type {
		return this.getById(id) || this.default;
	}
}

export { Type as KestrelVersion };
